const initialState = {
	button: false,
	loaded: false,
	records: [],
	error: false,
	error_message: [],
	success: false
}

export default function workExpReducers( state = initialState, action) {
	switch(action.type) {
		case 'WE_BUTTON': {
			return {
				...state,
				button: true
			}
		}
		case 'WE_BUTTON_OFF': {
			return {
				...state,
				button: false
			}
		}
		case 'WE_ERROR': {
			return {
				...state,
				button: false,
				error: true,
				error_message: action.payload,
				success: false
			}
		}
		case 'WE_SUCCESS': {
			return {
				...state,
				button: false,
				error: false,
				error_message: [],
				success: true,
				loaded: false,
			}
		}
		case 'WE_SUCCESS_OFF': {
			return {
				...state,
				success: false
			}
		}
		case 'WE_ERROR_OFF': {
			return {
				...state,
				error: false,
				error_message: [],
				button: false
			}
		}
		case 'WE_RECORDS': {
			return {
				...state,
				loaded: true,
				records: action.payload
			}
		}
		default: return state;
	}
}